import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoHousekeeping = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Housekeeping</title>
    <path
      d="M5.133 12.63v0A1.633 1.633 0 0 1 3.5 10.995v0c0-.902.731-1.633 1.633-1.633v0m0 3.266.626 10.004a3.267 3.267 0 0 0 3.26 3.063H22.48a3.267 3.267 0 0 0 3.26-3.063l.626-10.004m-21.234 0h21.234m0 0v0c.902 0 1.633-.73 1.633-1.633v0c0-.902-.731-1.633-1.633-1.633v0m-21.234 0h21.234m-21.234 0-.468-.468a1.696 1.696 0 0 1-.034-2.364v0C4.951 6.192 5.398 6 5.864 6h19.772c.466 0 .912.192 1.233.531v0c.63.668.615 1.715-.034 2.364l-.468.468"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m20.137 18.212-.154.403a1.671 1.671 0 0 1-1.561 1.076h-5.03a1.671 1.671 0 0 1-1.56-1.076l-.155-.403a1.035 1.035 0 0 1 .967-1.404h6.527a1.034 1.034 0 0 1 .966 1.404Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoHousekeeping;
